import { type Dispatch, type SetStateAction, useEffect } from 'react'

/** Clears the pen-edit hover cursor on leaving the pen-edit sub-mode. */
export function usePenEditHoverReset({
  isPenEditMode,
  setPenEditHoverKind,
}: {
  isPenEditMode: boolean
  setPenEditHoverKind: Dispatch<SetStateAction<'endpoint' | 'anchor' | 'segment' | null>>
}) {
  // Clear pen-edit hover cursor when exiting pen-edit sub-mode.
  useEffect(() => {
    if (!isPenEditMode) setPenEditHoverKind(null)
  }, [isPenEditMode, setPenEditHoverKind])
}
